export const projectManagementTranslations = {
  'projectManagement.title': {
    en: 'Project Management',
    fi: 'Projektinhallinta'
  },
  'projectManagement.createNewProject': {
    en: 'Create New Project',
    fi: 'Perusta uusi projekti'
  },
  'projectManagement.searchPlaceholder': {
    en: 'Search by customer, project or subproject name...',
    fi: 'Etsi asiakkaan, projektin tai osaprojektin nimellä...'
  },
  'projectManagement.noSearchResults': {
    en: 'No search results for',
    fi: 'Ei hakutuloksia haulle'
  },
  'projectManagement.noProjects': {
    en: 'No projects',
    fi: 'Ei projekteja'
  },
  'projectManagement.subprojects': {
    en: 'subprojects',
    fi: 'osaprojektia'
  },
  'projectManagement.subproject': {
    en: 'subproject',
    fi: 'osaprojekti'
  },
  'projectManagement.notBillable': {
    en: 'Not billable',
    fi: 'Ei laskutettava'
  },
  'projectManagement.fixedPrice': {
    en: 'Fixed price',
    fi: 'Kiinteähintainen'
  },
  'projectManagement.descRequired': {
    en: 'Description required for time entries',
    fi: 'Selite pakollinen tuntikirjauksille'
  },
  'projectManagement.subprojectDetail': {
    en: 'Subproject Detail',
    fi: 'Osaprojektin tiedot'
  },
  'projectManagement.comingSoon': {
    en: 'Coming soon...',
    fi: 'Tulossa pian...'
  },
  'projectManagement.basicInfo': {
    en: 'Basic Information',
    fi: 'Perustiedot'
  },
  'projectManagement.name': {
    en: 'Name',
    fi: 'Nimi'
  },
  'projectManagement.startDate': {
    en: 'Start Date',
    fi: 'Aloituspäivä'
  },
  'projectManagement.endDate': {
    en: 'End Date',
    fi: 'Päättymispäivä'
  },
  'projectManagement.billable': {
    en: 'Billable',
    fi: 'Laskutettava'
  },
  'projectManagement.yes': {
    en: 'Yes',
    fi: 'Kyllä'
  },
  'projectManagement.no': {
    en: 'No',
    fi: 'Ei'
  },
  'projectManagement.customer': {
    en: 'Customer',
    fi: 'Asiakas'
  },
  'projectManagement.project': {
    en: 'Project',
    fi: 'Projekti'
  },
  'projectManagement.created': {
    en: 'Created',
    fi: 'Luotu'
  },
  'projectManagement.updated': {
    en: 'Updated',
    fi: 'Päivitetty'
  },
  'projectManagement.sales': {
    en: 'Sales',
    fi: 'Myynnit'
  },
  'projectManagement.addSale': {
    en: 'Add Sale',
    fi: 'Lisää myynti'
  },
  'projectManagement.noSales': {
    en: 'No sales',
    fi: 'Ei myyntejä'
  },
  'projectManagement.productDescription': {
    en: 'Product / Description',
    fi: 'Tuote / Selite'
  },
  'projectManagement.quantity': {
    en: 'Quantity',
    fi: 'Määrä'
  },
  'projectManagement.unitPrice': {
    en: 'Unit Price €',
    fi: 'Hinta €/kpl'
  },
  'projectManagement.vat': {
    en: 'VAT %',
    fi: 'ALV %'
  },
  'projectManagement.totalWithVat': {
    en: 'Total (incl. VAT)',
    fi: 'Yhteensä (sis. ALV)'
  },
  'projectManagement.billingDate': {
    en: 'Billing Date',
    fi: 'Laskutuspäivä'
  },
  'projectManagement.status': {
    en: 'Status',
    fi: 'Status'
  },
  'projectManagement.readyForBilling': {
    en: 'Ready for billing',
    fi: 'Valmis laskutettavaksi'
  },
  'projectManagement.inProgress': {
    en: 'In Progress',
    fi: 'Kesken'
  },
  'projectManagement.deleteSale': {
    en: 'Delete Sale',
    fi: 'Poista myynti'
  },
  'projectManagement.deleteSaleConfirm': {
    en: 'Are you sure you want to delete this sale? This action cannot be undone.',
    fi: 'Haluatko varmasti poistaa tämän myynnin? Toimintoa ei voi perua.'
  },
  'projectManagement.saleDeleted': {
    en: 'Sale deleted',
    fi: 'Myynti poistettu'
  },
  'projectManagement.saleAdded': {
    en: 'Sale added',
    fi: 'Myynti lisätty'
  },
  'projectManagement.subprojectUpdated': {
    en: 'Subproject updated',
    fi: 'Osaprojekti päivitetty'
  },
  'projectManagement.saleUpdated': {
    en: 'Sale updated',
    fi: 'Myynti päivitetty'
  },
  'projectManagement.billableEnabled': {
    en: 'Billable enabled',
    fi: 'Laskutettava käytössä'
  },
  'projectManagement.billableDisabled': {
    en: 'Billable disabled',
    fi: 'Laskutettava poistettu käytöstä'
  },
  'projectManagement.fixedPriceEnabled': {
    en: 'Fixed price enabled',
    fi: 'Kiinteähintainen käytössä'
  },
  'projectManagement.fixedPriceDisabled': {
    en: 'Fixed price disabled',
    fi: 'Kiinteähintainen poistettu käytöstä'
  },
  'projectManagement.editSale': {
    en: 'Edit Sale',
    fi: 'Muokkaa myyntiä'
  },
  'projectManagement.selectProduct': {
    en: 'Select product',
    fi: 'Valitse tuote'
  },
  'projectManagement.selectProductPlaceholder': {
    en: '– Select product –',
    fi: '– Valitse tuote –'
  },
  'projectManagement.invoiceLineDescription': {
    en: 'Invoice line description',
    fi: 'Laskurivin selite'
  },
  'projectManagement.invoiceLineDescriptionPlaceholder': {
    en: 'Invoice line description',
    fi: 'Laskurivin kuvaus'
  },
  'projectManagement.code': {
    en: 'Code',
    fi: 'Koodi'
  },
  'projectManagement.codePlaceholder': {
    en: 'e.g. CONS-001',
    fi: 'esim. KONS-001'
  },
  'projectManagement.quantityLabel': {
    en: 'Quantity',
    fi: 'Määrä'
  },
  'projectManagement.unitPriceLabel': {
    en: 'Unit price €',
    fi: 'Myyntihinta €/kpl'
  },
  'projectManagement.vatLabel': {
    en: 'VAT %',
    fi: 'ALV %'
  },
  'projectManagement.billingDateLabel': {
    en: 'Billing Date',
    fi: 'Laskutuspäivä'
  },
  'projectManagement.statusInProgress': {
    en: 'In Progress',
    fi: 'Kesken'
  },
  'projectManagement.statusReady': {
    en: 'Ready for billing',
    fi: 'Valmis laskutettavaksi'
  },
  'projectManagement.totalExclVat': {
    en: 'Total (excl. VAT)',
    fi: 'Yhteensä (ilman ALV)'
  },
  'projectManagement.totalInclVat': {
    en: 'Total (incl. VAT {vat}%)',
    fi: 'Yhteensä (sis. ALV {vat} %)'
  },
  'projectManagement.save': {
    en: 'Save',
    fi: 'Tallenna'
  },
  'projectManagement.validationProductRequired': {
    en: 'Select a product',
    fi: 'Valitse tuote'
  },
  'projectManagement.validationQuantityRequired': {
    en: 'Enter a valid quantity',
    fi: 'Anna kelvollinen määrä'
  },
  'projectManagement.validationPriceRequired': {
    en: 'Enter a valid price',
    fi: 'Anna kelvollinen hinta'
  },
  'projectManagement.validationBillingDateRequired': {
    en: 'Select a billing date',
    fi: 'Valitse laskutuspäivä'
  },
  'projectManagement.basicInfoTitle': {
    en: 'Basic Information',
    fi: 'Perustiedot'
  },
  'projectManagement.basicInfoDescription': {
    en: 'Enter the basic project information.',
    fi: 'Syötä projektin perustiedot.'
  },
  'projectManagement.projectNumber': {
    en: 'Project Number',
    fi: 'Projektinumero'
  },
  'projectManagement.customerLabel': {
    en: 'Customer',
    fi: 'Asiakas'
  },
  'projectManagement.selectCustomer': {
    en: 'Select customer',
    fi: 'Valitse asiakas'
  },
  'projectManagement.projectName': {
    en: 'Project Name',
    fi: 'Projektin nimi'
  },
  'projectManagement.projectNamePlaceholder': {
    en: 'e.g. Office Renovation 2024',
    fi: 'esim. Toimistosaneeraus 2024'
  },
  'projectManagement.startDateLabel': {
    en: 'Start Date',
    fi: 'Aloituspäivä'
  },
  'projectManagement.endDateLabel': {
    en: 'End Date',
    fi: 'Päättymispäivä'
  },
  'projectManagement.statusLabel': {
    en: 'Status',
    fi: 'Status'
  },
  'projectManagement.statusActive': {
    en: 'Active',
    fi: 'Aktiivinen'
  },
  'projectManagement.statusDone': {
    en: 'Completed',
    fi: 'Valmistunut'
  },
  'projectManagement.selectBusinessArea': {
    en: 'Select area',
    fi: 'Valitse alue'
  },
  'projectManagement.projectLead': {
    en: 'Project Manager',
    fi: 'Projektipäällikkö'
  },
  'projectManagement.selectProjectLead': {
    en: 'Select project manager',
    fi: 'Valitse projektipäällikkö'
  },
  'projectManagement.customerRep': {
    en: 'Customer Representative',
    fi: 'Asiakasvastaava'
  },
  'projectManagement.selectCustomerRep': {
    en: 'Select customer representative',
    fi: 'Valitse asiakasvastaava'
  },
  'projectManagement.billingInfoTitle': {
    en: 'Billing Information',
    fi: 'Laskutustiedot'
  },
  'projectManagement.billingInfoDescriptionWithCustomer': {
    en: 'Information pre-filled from the selected customer. You can edit if needed.',
    fi: 'Tiedot esitäytetty valitun asiakkaan tiedoilla. Voit muokata niitä tarvittaessa.'
  },
  'projectManagement.billingInfoDescriptionNoCustomer': {
    en: 'Select a customer first, and the information will be filled automatically.',
    fi: 'Valitse ensin asiakas, niin tiedot täytetään automaattisesti.'
  },
  'projectManagement.billingAddress': {
    en: 'Billing Address',
    fi: 'Laskutusosoite'
  },
  'projectManagement.streetAddressPlaceholder': {
    en: 'Street address',
    fi: 'Katuosoite'
  },
  'projectManagement.postalCodePlaceholder': {
    en: 'Postal code',
    fi: 'Postinumero'
  },
  'projectManagement.cityPlaceholder': {
    en: 'City',
    fi: 'Kaupunki'
  },
  'projectManagement.countryPlaceholder': {
    en: 'Country',
    fi: 'Maa'
  },
  'projectManagement.contractNumberLabel': {
    en: 'Contract Number',
    fi: 'Sopimusnumero'
  },
  'projectManagement.contractNumberPlaceholder': {
    en: 'e.g. SOP-2024-001',
    fi: 'esim. SOP-2024-001'
  },
  'projectManagement.accountingRefLabel': {
    en: 'Accounting Reference',
    fi: 'Tiliöintiviite'
  },
  'projectManagement.accountingRefPlaceholder': {
    en: 'e.g. 1234-5678',
    fi: 'esim. 1234-5678'
  },
  'projectManagement.buyerRefLabel': {
    en: 'Buyer Reference',
    fi: 'Ostajan viitetunniste'
  },
  'projectManagement.buyerRefPlaceholder': {
    en: 'e.g. BUY-001',
    fi: 'esim. BUY-001'
  },
  'projectManagement.paymentTermLabel': {
    en: 'Payment Term',
    fi: 'Maksuehto'
  },
  'projectManagement.days': {
    en: 'days',
    fi: 'päivää'
  },
  'projectManagement.contactNameLabel': {
    en: 'Contact Person',
    fi: 'Yhteyshenkilö'
  },
  'projectManagement.contactNamePlaceholder': {
    en: 'e.g. Henna Järvinen',
    fi: 'esim. Henna Järvinen'
  },
  'projectManagement.invoiceNoteLabel': {
    en: 'Invoice Additional Text',
    fi: 'Laskun lisäteksti'
  },
  'projectManagement.timeEntriesInInvoice': {
    en: 'Automatically attach time entry report to invoice',
    fi: 'Tuntikirjausliite automaattisesti laskun liitteeksi'
  },
  'projectManagement.invoiceNotePlaceholder': {
    en: 'Optional additional text for the invoice',
    fi: 'Vapaaehtoinen lisäteksti laskulle'
  },
  'projectManagement.priceList': {
    en: 'Price List',
    fi: 'Hinnasto'
  },
  'projectManagement.selectPriceListForProject': {
    en: 'Select a price list to use for this project.',
    fi: 'Valitse projektille käytettävä hinnasto.'
  },
  'projectManagement.createNewPriceList': {
    en: 'Create new price list',
    fi: 'Luo uusi hinnasto'
  },
  'projectManagement.createNewPriceListDesc': {
    en: 'Define a custom price list for the project.',
    fi: 'Määritä projektille oma hinnasto.'
  },
  'projectManagement.projectSpecificPriceList': {
    en: 'Project-specific price list',
    fi: 'Projektikohtainen hinnasto'
  },
  'projectManagement.generalPriceList': {
    en: 'General price list',
    fi: 'Yleinen hinnasto'
  },
  'projectManagement.newPriceList': {
    en: 'New Price List',
    fi: 'Uusi hinnasto'
  },
  'projectManagement.selectPriceList': {
    en: 'Select Price List',
    fi: 'Valitse hinnasto'
  },
  'projectManagement.priceListSaved': {
    en: 'Price list saved',
    fi: 'Hinnasto tallennettu'
  },
  'projectManagement.priceListSavedSuccessfully': {
    en: 'Price list has been saved successfully.',
    fi: 'Hinnasto on tallennettu onnistuneesti.'
  },
  'projectManagement.priceListSelected': {
    en: 'Price list selected',
    fi: 'Hinnasto valittu'
  },
  'projectManagement.hasBeenSelected': {
    en: 'has been selected',
    fi: 'on valittu'
  },
  'projectManagement.selectedPriceListNotAvailable': {
    en: 'The selected price list is no longer available. Please select a different price list.',
    fi: 'Valittu hinnasto ei ole enää saatavilla. Valitse toinen hinnasto.'
  },
  'projectManagement.subprojects.defaultName': {
    en: 'Subproject {index}',
    fi: 'Osaprojekti {index}'
  },
  'projectManagement.subprojects.name': {
    en: 'Subproject Name',
    fi: 'Osaprojektin nimi'
  },
  'projectManagement.subprojects.namePlaceholder': {
    en: 'e.g. Architecture Design',
    fi: 'esim. Arkkitehtisuunnittelu'
  },
  'projectManagement.subprojects.selectMember': {
    en: 'Select member',
    fi: 'Valitse jäsen'
  },
  'projectManagement.subprojects.enterRole': {
    en: 'Enter price group',
    fi: 'Syötä hintaryhmä'
  },
  'projectManagement.subprojects.selectRole': {
    en: 'Select price group',
    fi: 'Valitse hintaryhmä'
  },
  'projectManagement.subprojects.defaultRole': {
    en: 'default',
    fi: 'oletus'
  },
  'projectManagement.subprojects.members': {
    en: 'Members',
    fi: 'Jäsenet'
  },
  'projectManagement.subprojects.addMember': {
    en: 'Add member',
    fi: 'Lisää jäsen'
  },
  'projectManagement.subprojects.noMembers': {
    en: 'No members — add members to the subproject.',
    fi: 'Ei jäseniä — lisää jäseniä osaprojektille.'
  },
  'projectManagement.subprojects.memberLabel': {
    en: 'Member',
    fi: 'Jäsen'
  },
  'projectManagement.subprojects.roleLabel': {
    en: 'Price Group',
    fi: 'Hintaryhmä'
  },
  'projectManagement.subprojects.startLabel': {
    en: 'Start',
    fi: 'Aloitus'
  },
  'projectManagement.subprojects.endLabel': {
    en: 'End',
    fi: 'Lopetus'
  },
  'projectManagement.subprojects.changeRoleOrder': {
    en: 'Change price group order',
    fi: 'Muuta hintaryhmien järjestystä'
  },
  'projectManagement.subprojects.roleOrderHint': {
    en: 'Drag to arrange the price groups of this member. First is default.',
    fi: 'Järjestä jäsenen hintaryhmät vetämällä. Ensimmäinen on oletus.'
  },
  'projectManagement.subprojects.customerInvoiceRef': {
    en: 'Customer Invoice Reference',
    fi: 'Asiakkaan laskuviite'
  },
  'projectManagement.subprojects.customerInvoiceRefPlaceholder': {
    en: 'e.g. PROJ-2024',
    fi: 'esim. PROJ-2024'
  },
  'projectManagement.subprojects.salaryTypes': {
    en: 'Salary Types',
    fi: 'Palkkalajit'
  },
  'projectManagement.subprojects.loading': {
    en: 'Loading...',
    fi: 'Ladataan...'
  },
  'projectManagement.subprojects.noSubprojects': {
    en: 'No subprojects',
    fi: 'Ei osaprojekteja'
  },
  'projectManagement.subprojects.noSubprojectsDescription': {
    en: 'Add subprojects to the project and assign members to them.',
    fi: 'Lisää projektille osaprojekteja ja määritä niille jäsenet.'
  },
  'projectManagement.subprojects.addSubproject': {
    en: 'Add subproject',
    fi: 'Lisää osaprojekti'
  },
  'projectManagement.back': {
    en: 'Back',
    fi: 'Takaisin'
  },
  'projectManagement.newProject': {
    en: 'New Project',
    fi: 'Uusi projekti'
  },
  'projectManagement.allRequiredFieldsComplete': {
    en: 'All required fields completed',
    fi: 'Kaikki pakolliset tiedot täytetty'
  },
  'projectManagement.fillBillingInfoFirst': {
    en: 'Fill in billing information first',
    fi: 'Täytä laskutustiedot ensin'
  },
  'projectManagement.fillBasicInfoFirst': {
    en: 'Fill in basic information first',
    fi: 'Täytä perustiedot ensin'
  },
  'projectManagement.createProject': {
    en: 'Create Project',
    fi: 'Luo projekti'
  },
  'projectManagement.creating': {
    en: 'Creating...',
    fi: 'Luodaan...'
  },
  'projectManagement.projectCreated': {
    en: 'Project created',
    fi: 'Projekti luotu'
  },
  'projectManagement.projectCreatedSuccessfully': {
    en: 'Project has been created successfully',
    fi: 'Projekti on luotu onnistuneesti'
  },
  'projectManagement.projectCreationFailed': {
    en: 'Project creation failed',
    fi: 'Projektin luominen epäonnistui'
  },
  'projectManagement.editProject': {
    en: 'Edit Project',
    fi: 'Muokkaa projektia'
  },
  'projectManagement.updating': {
    en: 'Saving...',
    fi: 'Tallennetaan...'
  },
  'projectManagement.updateProject': {
    en: 'Save Changes',
    fi: 'Tallenna muutokset'
  },
  'projectManagement.projectUpdated': {
    en: 'Project updated',
    fi: 'Projekti päivitetty'
  },
  'projectManagement.projectUpdatedSuccessfully': {
    en: 'Project has been updated successfully',
    fi: 'Projekti on päivitetty onnistuneesti'
  },
  'projectManagement.projectUpdateFailed': {
    en: 'Project update failed',
    fi: 'Projektin päivitys epäonnistui'
  },
  'projectManagement.loadingFailed': {
    en: 'Loading failed',
    fi: 'Lataus epäonnistui'
  },
  'projectManagement.tasks': {
    en: 'Time Entry Targets',
    fi: 'Tuntikirjauskohteet'
  },
  'projectManagement.addTask': {
    en: 'Add Task',
    fi: 'Lisää tehtävä'
  },
  'projectManagement.noTasks': {
    en: 'No tasks',
    fi: 'Ei tehtäviä'
  },
  'projectManagement.taskDescription': {
    en: 'Description',
    fi: 'Kuvaus'
  },
  'projectManagement.taskJiraKey': {
    en: 'JIRA Key',
    fi: 'JIRA-avain'
  },
  'projectManagement.taskDescriptionPlaceholder': {
    en: 'Enter task description',
    fi: 'Syötä tehtävän kuvaus'
  },
  'projectManagement.taskJiraKeyPlaceholder': {
    en: 'e.g. PROJ-123',
    fi: 'esim. PROJ-123'
  },
  'projectManagement.deleteTask': {
    en: 'Delete Task',
    fi: 'Poista tehtävä'
  },
  'projectManagement.deleteTaskConfirm': {
    en: 'Are you sure you want to delete this task? This action cannot be undone.',
    fi: 'Haluatko varmasti poistaa tämän tehtävän? Toimintoa ei voi perua.'
  },
  'projectManagement.taskDeleted': {
    en: 'Task deleted',
    fi: 'Tehtävä poistettu'
  },
  'projectManagement.taskAdded': {
    en: 'Task added',
    fi: 'Tehtävä lisätty'
  },
  'projectManagement.taskUpdated': {
    en: 'Task updated',
    fi: 'Tehtävä päivitetty'
  },
  'projectManagement.taskDescriptionRequired': {
    en: 'Description is required',
    fi: 'Kuvaus on pakollinen'
  },
  'projectManagement.newTaskDescription': {
    en: 'New Task',
    fi: 'Uusi tehtävä'
  },
  'projectManagement.descriptionRequired': {
    en: 'Description required for time entries',
    fi: 'Kuvaus pakollinen tuntikirjauksille'
  },
  'projectManagement.memberFieldsRequired': {
    en: 'Please fill in all required member fields',
    fi: 'Täytä kaikki pakolliset jäsentiedot'
  },
  'projectManagement.memberAdded': {
    en: 'Member added',
    fi: 'Jäsen lisätty'
  },
  'projectManagement.memberUpdated': {
    en: 'Member updated',
    fi: 'Jäsen päivitetty'
  },
  'projectManagement.memberDeleted': {
    en: 'Member deleted',
    fi: 'Jäsen poistettu'
  },
  'projectManagement.isRecurring': {
    en: 'Recurring',
    fi: 'Toistuva'
  },
  'projectManagement.recurringEndDate': {
    en: 'Recurring end date',
    fi: 'Toistuvuuden päättymispäivä'
  },
  'projectManagement.recurringInterval': {
    en: 'Billing date',
    fi: 'Laskutuspäivä'
  },
  'projectManagement.recurringStartDate': {
    en: 'Recurring start date',
    fi: 'Toistuvuuden aloituspäivä'
  },
  'projectManagement.recurringIntervalPlaceholder': {
    en: 'Select day',
    fi: 'Valitse päivä'
  },
  'projectManagement.validation.missingFields': {
    en: 'Required fields missing:',
    fi: 'Pakollisia tietoja puuttuu:'
  },
  'projectManagement.validation.taskDescription': {
    en: 'task description',
    fi: 'tehtävän kuvaus'
  },
  'projectManagement.validation.saleProduct': {
    en: 'sale product',
    fi: 'myynnin tuote'
  },
  'projectManagement.validation.saleDescription': {
    en: 'sale description',
    fi: 'myynnin selite'
  },
  'projectManagement.validation.saleQuantity': {
    en: 'sale quantity',
    fi: 'myynnin määrä'
  },
  'projectManagement.validation.salePrice': {
    en: 'sale price',
    fi: 'myynnin hinta'
  },
  'projectManagement.validation.saleVat': {
    en: 'sale VAT',
    fi: 'myynnin ALV'
  },
  'projectManagement.validation.memberExpert': {
    en: 'member',
    fi: 'jäsen'
  },
  'projectManagement.validation.memberRole': {
    en: 'member price group',
    fi: 'jäsenen hintaryhmä'
  },
  'projectManagement.validation.memberStartDate': {
    en: 'member start date',
    fi: 'jäsenen aloituspäivä'
  },
  'projectManagement.recurringIntervalLastDay': {
    en: 'Last day of the month',
    fi: 'Kuukauden viimeinen päivä'
  }
};
